/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfGetDynamicTemplateListDto } from '../models/custom-result-of-list-of-get-dynamic-template-list-dto';
import { CustomResultOfPaginatedListOfGetDynamicTemplatesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-dynamic-templates-with-pagination-dto';
import { dynamicTemplatesCreateDynamicTemplateGet } from '../fn/dynamic-templates/dynamic-templates-create-dynamic-template-get';
import { DynamicTemplatesCreateDynamicTemplateGet$Params } from '../fn/dynamic-templates/dynamic-templates-create-dynamic-template-get';
import { dynamicTemplatesCreateDynamicTemplatePost } from '../fn/dynamic-templates/dynamic-templates-create-dynamic-template-post';
import { DynamicTemplatesCreateDynamicTemplatePost$Params } from '../fn/dynamic-templates/dynamic-templates-create-dynamic-template-post';
import { dynamicTemplatesDeleteDynamicTemplate } from '../fn/dynamic-templates/dynamic-templates-delete-dynamic-template';
import { DynamicTemplatesDeleteDynamicTemplate$Params } from '../fn/dynamic-templates/dynamic-templates-delete-dynamic-template';
import { dynamicTemplatesGetDynamicTemplateList } from '../fn/dynamic-templates/dynamic-templates-get-dynamic-template-list';
import { DynamicTemplatesGetDynamicTemplateList$Params } from '../fn/dynamic-templates/dynamic-templates-get-dynamic-template-list';
import { dynamicTemplatesGetDynamicTemplatesAuditWithPagination } from '../fn/dynamic-templates/dynamic-templates-get-dynamic-templates-audit-with-pagination';
import { DynamicTemplatesGetDynamicTemplatesAuditWithPagination$Params } from '../fn/dynamic-templates/dynamic-templates-get-dynamic-templates-audit-with-pagination';
import { dynamicTemplatesGetDynamicTemplatesWithPagination } from '../fn/dynamic-templates/dynamic-templates-get-dynamic-templates-with-pagination';
import { DynamicTemplatesGetDynamicTemplatesWithPagination$Params } from '../fn/dynamic-templates/dynamic-templates-get-dynamic-templates-with-pagination';
import { dynamicTemplatesUpdateDynamicTemplate } from '../fn/dynamic-templates/dynamic-templates-update-dynamic-template';
import { DynamicTemplatesUpdateDynamicTemplate$Params } from '../fn/dynamic-templates/dynamic-templates-update-dynamic-template';

@Injectable({ providedIn: 'root' })
export class DynamicTemplatesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dynamicTemplatesCreateDynamicTemplateGet()` */
  static readonly DynamicTemplatesCreateDynamicTemplateGetPath = '/DynamicTemplates/CreateDynamicTemplate';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicTemplatesCreateDynamicTemplateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dynamicTemplatesCreateDynamicTemplateGet$Response(params?: DynamicTemplatesCreateDynamicTemplateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return dynamicTemplatesCreateDynamicTemplateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicTemplatesCreateDynamicTemplateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dynamicTemplatesCreateDynamicTemplateGet(params?: DynamicTemplatesCreateDynamicTemplateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.dynamicTemplatesCreateDynamicTemplateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `dynamicTemplatesCreateDynamicTemplatePost()` */
  static readonly DynamicTemplatesCreateDynamicTemplatePostPath = '/DynamicTemplates/CreateDynamicTemplate';

  /**
   * Create Dynamic Template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicTemplatesCreateDynamicTemplatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dynamicTemplatesCreateDynamicTemplatePost$Response(params: DynamicTemplatesCreateDynamicTemplatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return dynamicTemplatesCreateDynamicTemplatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Dynamic Template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicTemplatesCreateDynamicTemplatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dynamicTemplatesCreateDynamicTemplatePost(params: DynamicTemplatesCreateDynamicTemplatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.dynamicTemplatesCreateDynamicTemplatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `dynamicTemplatesUpdateDynamicTemplate()` */
  static readonly DynamicTemplatesUpdateDynamicTemplatePath = '/DynamicTemplates';

  /**
   * Update Dynamic Template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicTemplatesUpdateDynamicTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dynamicTemplatesUpdateDynamicTemplate$Response(params: DynamicTemplatesUpdateDynamicTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return dynamicTemplatesUpdateDynamicTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Dynamic Template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicTemplatesUpdateDynamicTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dynamicTemplatesUpdateDynamicTemplate(params: DynamicTemplatesUpdateDynamicTemplate$Params, context?: HttpContext): Observable<CustomResult> {
    return this.dynamicTemplatesUpdateDynamicTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `dynamicTemplatesDeleteDynamicTemplate()` */
  static readonly DynamicTemplatesDeleteDynamicTemplatePath = '/DynamicTemplates';

  /**
   * Delete Dynamic Template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicTemplatesDeleteDynamicTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  dynamicTemplatesDeleteDynamicTemplate$Response(params?: DynamicTemplatesDeleteDynamicTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return dynamicTemplatesDeleteDynamicTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Dynamic Template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicTemplatesDeleteDynamicTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dynamicTemplatesDeleteDynamicTemplate(params?: DynamicTemplatesDeleteDynamicTemplate$Params, context?: HttpContext): Observable<CustomResult> {
    return this.dynamicTemplatesDeleteDynamicTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `dynamicTemplatesGetDynamicTemplateList()` */
  static readonly DynamicTemplatesGetDynamicTemplateListPath = '/DynamicTemplates/GetDynamicTemplateList';

  /**
   * Get Dynamic Template List (useful for dropdown).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicTemplatesGetDynamicTemplateList()` instead.
   *
   * This method doesn't expect any request body.
   */
  dynamicTemplatesGetDynamicTemplateList$Response(params?: DynamicTemplatesGetDynamicTemplateList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetDynamicTemplateListDto>> {
    return dynamicTemplatesGetDynamicTemplateList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Dynamic Template List (useful for dropdown).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicTemplatesGetDynamicTemplateList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dynamicTemplatesGetDynamicTemplateList(params?: DynamicTemplatesGetDynamicTemplateList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetDynamicTemplateListDto> {
    return this.dynamicTemplatesGetDynamicTemplateList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetDynamicTemplateListDto>): CustomResultOfListOfGetDynamicTemplateListDto => r.body)
    );
  }

  /** Path part for operation `dynamicTemplatesGetDynamicTemplatesWithPagination()` */
  static readonly DynamicTemplatesGetDynamicTemplatesWithPaginationPath = '/DynamicTemplates/GetDynamicTemplatesWithPagination';

  /**
   * Get Dynamic Templates With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicTemplatesGetDynamicTemplatesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dynamicTemplatesGetDynamicTemplatesWithPagination$Response(params: DynamicTemplatesGetDynamicTemplatesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetDynamicTemplatesWithPaginationDto>> {
    return dynamicTemplatesGetDynamicTemplatesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Dynamic Templates With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicTemplatesGetDynamicTemplatesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dynamicTemplatesGetDynamicTemplatesWithPagination(params: DynamicTemplatesGetDynamicTemplatesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetDynamicTemplatesWithPaginationDto> {
    return this.dynamicTemplatesGetDynamicTemplatesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetDynamicTemplatesWithPaginationDto>): CustomResultOfPaginatedListOfGetDynamicTemplatesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `dynamicTemplatesGetDynamicTemplatesAuditWithPagination()` */
  static readonly DynamicTemplatesGetDynamicTemplatesAuditWithPaginationPath = '/DynamicTemplates/GetDynamicTemplatesAuditWithPagination';

  /**
   * Get Dynamic Templates Audit With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicTemplatesGetDynamicTemplatesAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dynamicTemplatesGetDynamicTemplatesAuditWithPagination$Response(params: DynamicTemplatesGetDynamicTemplatesAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return dynamicTemplatesGetDynamicTemplatesAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Dynamic Templates Audit With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicTemplatesGetDynamicTemplatesAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dynamicTemplatesGetDynamicTemplatesAuditWithPagination(params: DynamicTemplatesGetDynamicTemplatesAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.dynamicTemplatesGetDynamicTemplatesAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
